// Window size breakpoints
type WindowSize = 'desktop' | 'tablet' | 'mobile';

// Form types
type FormType =
  | 'requestQuote'
  | 'reserveYours'
  | 'preOrder'
  | 'serviceAppt'
  | 'testDrive'
  | 'tradeInValue'
  | 'tradeInValueBnp'
  | 'contactDealer'
  | 'getLocalPrice'
  | 'contact';

// PID data structure
interface PidDeviceValues {
  desktop: number;
  tablet: number;
  mobile: number;
}

interface PidFormTypes {
  [key: string]: PidDeviceValues;
}

interface PidData {
  mazda: {
    default: PidFormTypes;
  };
  cpo: {
    details: {
      contact: PidDeviceValues;
    };
    listing: {
      contact: PidDeviceValues;
    };
    saved: {
      contact: PidDeviceValues;
    };
  };
  buildPrice: PidFormTypes;
}

const pidController = (function () {
  const data: PidData = {
    mazda: {
      default: {
        requestQuote: {
          desktop: 247,
          tablet: 255,
          mobile: 251
        },
        reserveYours: {
          desktop: 101100154,
          tablet: 101100155,
          mobile: 101100156
        },
        preOrder: {
          desktop: 101100162,
          tablet: 101100163,
          mobile: 235
        },
        serviceAppt: {
          desktop: 601000,
          tablet: 101200101,
          mobile: 101200102
        },
        testDrive: {
          desktop: 237,
          tablet: 252,
          mobile: 248
        },
        tradeInValue: {
          desktop: 230,
          tablet: 232,
          mobile: 231
        },
        tradeInValueBnp: {
          desktop: 227,
          tablet: 229,
          mobile: 228
        },
        contactDealer: {
          desktop: 238,
          tablet: 254,
          mobile: 250
        },
        getLocalPrice: {
          desktop: 236,
          tablet: 234,
          mobile: 233
        }
      }
    },
    cpo: {
      details: {
        contact: {
          desktop: 240,
          tablet: 245,
          mobile: 243
        }
      },
      listing: {
        contact: {
          desktop: 241,
          tablet: 241,
          mobile: 244
        }
      },
      saved: {
        contact: {
          desktop: 239,
          tablet: 239,
          mobile: 242
        }
      }
    },
    buildPrice: {
      contactDealer: {
        desktop: 238,
        tablet: 254,
        mobile: 250
      },
      requestQuote: {
        desktop: 101100101,
        tablet: 101100117,
        mobile: 101100118
      },
      testDrive: {
        desktop: 257,
        tablet: 253,
        mobile: 249
      },
      preOrder: {
        desktop: 101100165,
        tablet: 101100166,
        mobile: 101100167
      }
    }
  };

  return {
    getPid: function (formType: string): number {
      let pidValue: number | null;
      let windowSize: WindowSize;
      const path = window.location.pathname;

      // Set window size
      if (window.outerWidth > 1025) {
        windowSize = 'desktop';
      } else if (window.outerWidth > 767) {
        windowSize = 'tablet';
      } else {
        windowSize = 'mobile';
      }

      if (path.search('build-and-price') >= 1 || path.search('construction-et-prix') >= 1) {
        try {
          pidValue = data['buildPrice'][formType][windowSize];
        } catch (err) {
          pidValue = null;
        }
      }
      // Otherwise
      else {
        try {
          pidValue = data['mazda']['default'][formType][windowSize];
        } catch (err) {
          pidValue = null;
        }
      }

      if (!pidValue) {
        pidValue = 0;
        console.log('Warning: pid not found in getPid in pidController.js');
      }
      return pidValue;
    },
  };
})();

export default pidController;
